import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "header",
  class: "header"
}
const _hoisted_2 = { class: "header__wrapper" }
const _hoisted_3 = { class: "header__contacts" }
const _hoisted_4 = {
  key: 0,
  class: "header__navbar"
}
const _hoisted_5 = { class: "header__navbar-menu" }
const _hoisted_6 = { class: "navbar__section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PInvitation = _resolveComponent("PInvitation")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMobile && _ctx.hasCard)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["header__menu", { active: _ctx.navMenu }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args)))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "header__menu-btn" }, null, -1)
          ]), 2))
        : _createCommentVNode("", true),
      _createVNode(_component_Logo),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "header__contacts-link",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("svg", {
            class: "header__contacts-link-pic",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", {
              d: "M16 17L21 12L16 7",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", {
              d: "M21 12H9",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)
        ]))
      ])
    ]),
    (_ctx.navMenu)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _createElementVNode("ul", {
                class: _normalizeClass(["navbar__list a-font__nav", { 'no-margin-last-child': !_ctx.hasActivePhysicalUserCard }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navbarItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index + 'li',
                    class: "navbar__item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navMenu = false))
                  }, [
                    (_openBlock(), _createBlock(_component_router_link, {
                      key: index,
                      class: _normalizeClass(["navbar__link", { main: index === 0 }]),
                      to: item.path
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(item.title)), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "to"]))
                  ]))
                }), 128))
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BaseDialog, {
      modelValue: _ctx.showInvitation,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showInvitation) = $event)),
      close: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PInvitation, { onClose: _ctx.popupClose }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_BaseDialog, {
      modelValue: _ctx.tokenOut,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tokenOut) = $event))
    }, {
      default: _withCtx(() => _cache[7] || (_cache[7] = [
        _createElementVNode("section", { class: "navbar__popup" }, [
          _createElementVNode("h3", { class: "a-font__h3" }, " Пока не работает =( "),
          _createElementVNode("p", { class: "a-font__l" }, " Данная функция вскоре будет доступна 😇 ")
        ], -1)
      ])),
      _: 1,
      __: [7]
    }, 8, ["modelValue"])
  ]))
}